import { toApiCanadaPostalCode } from 'src/common/validation/converters/CanadaPostalCode';
import { Country } from 'src/types';
import type { IAddress } from 'src/types/IAddress';

export function toApiAddress(address: IAddress): IAddress {
  if (address.country === Country.Canada) {
    return {
      country: address.country,
      street: address.street,
      city: address.city,
      region: address.region,

      postalCode: address.postalCode != null ? toApiCanadaPostalCode(address.postalCode) : null,
    };
  }

  // Avoid unnecessary fields from `...address`
  return {
    country: address.country,
    street: address.street,
    city: address.city,
    region: address.region,
    postalCode: address.postalCode,
  };
}
